
import 'bootstrap-css-only/css/bootstrap.min.css'
import 'mdbvue/lib/css/mdb.min.css'
import '@fortawesome/fontawesome-free/css/all.min.css'

import 'mdbvue/lib/mdbvue.css'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios';
Vue.prototype.$http = axios;

// interceptor für Antworten, die mitteilen, dass der user ausgeloggt werden soll (zB token nicht mehr gültig)
axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status == 401 && error.response.data == "logout") {
    // kann nicht schaden
    store.commit("logoutUser");
    // Seite neu laden (für evtl. Umleitung auf nicht-geschützte Seite)
    location.reload();
  }
  return Promise.reject(error);
});

// make all mdb components available globally
import * as mdbvue from 'mdbvue'
for (const component in mdbvue) {
  Vue.component(component, mdbvue[component])
}
// end make all mdb components available globally

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
